<button mat-stroked-button class="new-savings-goal section-background-color__{{section}}" (click)="onNewClick()">
  <i class="material-icons">{{this.icon}}</i><span class="paragraph1">{{title}}</span>
</button>
